import { useState } from "react";
import { Brokers, SyncSetting } from "../../../types";
import { track, EVENTS } from "../../../utils/analytics";

export interface AddOrEditConfigurationProps {
  settings?: SyncSetting;
  close: () => void;
}

interface useAddOrEditConfigurationControllerResponse {
  new: boolean;
  settings?: SyncSetting;
  selectedBroker?: Brokers;
  setSelectedBroker: (broker: Brokers) => void;
}

export const useAddOrEditConfigurationController = (
  props: AddOrEditConfigurationProps
): useAddOrEditConfigurationControllerResponse => {
  const [selectedBroker, setSelectedBroker] = useState<Brokers | undefined>(
    props.settings?.broker
  );

  // Track broker selection
  const setSelectedBrokerWithTracking = (broker: Brokers) => {
    track(EVENTS.AUTOSYNC.BROKER_CONNECTED, {
      broker,
      isNew: props.settings === undefined,
    });
    setSelectedBroker(broker);
  };

  return {
    new: props.settings === undefined,
    settings: props.settings,
    selectedBroker,
    setSelectedBroker: setSelectedBrokerWithTracking,
  };
};
